import { render } from "./Logic.vue?vue&type=template&id=995a2590"
import script from "./Logic.vue?vue&type=script&lang=js"
export * from "./Logic.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__